// Tracks whether the admin app has already finished its initial data load in this
// browser tab. Used to tell a real first load (show the full-screen Loading gate)
// apart from a page refresh of an already-bootstrapped session (reload silently,
// keep the header/layout mounted while data refetches in the background).
const BOOT_FLAG_KEY = 'rl_admin_app_bootstrapped';

export const hasBootstrappedBefore = () => {
  try {
    return sessionStorage.getItem(BOOT_FLAG_KEY) === '1';
  } catch {
    return false;
  }
};

export const markBootstrapped = () => {
  try {
    sessionStorage.setItem(BOOT_FLAG_KEY, '1');
  } catch {
    // sessionStorage unavailable (private browsing, disabled storage) — safe to ignore.
  }
};

// Call on logout and on app-version upgrade so the next boot (next login, or the
// forced reload after an upgrade) shows the real full-screen Loading gate instead of
// silently reusing a previous user's/version's bootstrap state.
export const clearBootstrapFlag = () => {
  try {
    sessionStorage.removeItem(BOOT_FLAG_KEY);
  } catch {
    // sessionStorage unavailable (private browsing, disabled storage) — safe to ignore.
  }
};
